/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackctasubtext3Inputs */

const en_artifactpackctasubtext3 = /** @type {(inputs: Artifactpackctasubtext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time payment · EU VAT included · download instantly`)
};

const pt_artifactpackctasubtext3 = /** @type {(inputs: Artifactpackctasubtext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento único · IVA da UE incluído · transferência imediata`)
};

/**
* | output |
* | --- |
* | "One-time payment · EU VAT included · download instantly" |
*
* @param {Artifactpackctasubtext3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackctasubtext3 = /** @type {((inputs?: Artifactpackctasubtext3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackctasubtext3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackctasubtext3(inputs)
	return pt_artifactpackctasubtext3(inputs)
});
export { artifactpackctasubtext3 as "artifactPackCtaSubtext" }